enum EventTypology {
    Ticket = "Ticket",
    Absence = "Absence"
}

export default EventTypology;